import _ from "lodash";
import { isFailure } from "@sportal/api";
import { Durations } from "@sportal/api/reports";

import {
  CsvExportState,
  ReportKeys,
  ReportTypes,
} from "../../helpers/reports.helper.types";
import { downloadCsvFile } from "./reports.helpers";
import { getCSVExportState } from "./reports.selectors";

//This mapping needs for consistency with SC reports
//it will help us to move some logic to /cdk
const mapDataToReportKeys = (data, type) =>
  _.map(data, ({ value, time }) => ({
    [ReportKeys[type]]: value,
    time,
  }));

const mergeObjects = (data) =>
  _.reduce(
    data,
    (memo, obj) => {
      // This part is for solving the issue EPORTAL-8820.
      // It's happening because of more number of proxy-transactions than dns-queries.
      // The current solution is just to add the value of blocked requests to activity,
      // we able to do it because we show the approximate value an activity

      if (obj[ReportTypes.Webfilter]) {
        memo[ReportTypes.Activity] = _.sum([
          memo[ReportTypes.Activity],
          obj[ReportTypes.Webfilter],
        ]);
      }

      return { ...memo, ...obj };
    },
    {}
  );

export const mergeData = (data) =>
  _.chain(data)
    .flatMap(mapDataToReportKeys)
    .groupBy("time")
    .map(mergeObjects)
    .value();

const getGranularity = (period) => {
  switch (+period) {
    case 7:
      return "2h";
    case 30:
      return "8h";
    default:
      return "15m";
  }
};

export const fetchReport =
  (endpoint, options, method) =>
  async (dispatch, getState, { api }) => {
    const { subscriberInfo } = getState();
    const { period, profile, withGranularity, limit } = options;
    const durationMap = {
      1: Durations.Day,
      7: Durations.Week,
      30: Durations.Month,
    };
    const duration = durationMap[period];
    const granularity = withGranularity ? getGranularity(period) : "";

    const result = await api.ssm.reports[method](
      `${endpoint}${granularity}`,
      subscriberInfo.id,
      duration,
      profile,
      limit,
      false
    );

    return Promise.resolve(result);
  };

const RESET_STATE_TIMEOUT = 5000;

export const exportCsv =
  (href) =>
  async (dispatch, getState, { api }) => {
    dispatch(updateCsvExportState(CsvExportState.IN_PROGRESS));

    try {
      const result = await api.ssm.reports.getDrilldownsCsv(href);

      if (isFailure(result)) {
        dispatch(updateCsvExportState(CsvExportState.FAILURE));
        return Promise.reject(result.error);
      }

      await downloadCsvFile(result.data.content, result.data.fileName);

      dispatch(updateCsvExportState(CsvExportState.SUCCESS));
    } catch (error) {
      dispatch(updateCsvExportState(CsvExportState.FAILURE));
    } finally {
      setTimeout(() => {
        const state = getState();
        const CSVExportState = getCSVExportState(state);

        CSVExportState !== CsvExportState.IN_PROGRESS &&
          dispatch(updateCsvExportState(CsvExportState.NOT_STARTED));
      }, RESET_STATE_TIMEOUT);
    }
  };

export const CHANGE_PERIOD = "[REPORTS] CHANGE_PERIOD";
export const CHANGE_PROFILE = "[REPORTS] CHANGE_PROFILE";
export const APPLY_ZOOM = "[REPORTS] APPLY ZOOM";
export const CANCEL_ZOOM = "[REPORTS] CANCEL ZOOM";
export const UPDATE_CSV_EXPORT_STATE = "[REPORTS] UPDATE_CSV_EXPORT_STATE";

export const changePeriod = (period) => ({
  type: CHANGE_PERIOD,
  payload: { period },
});

export const changeProfile = (profile) => ({
  type: CHANGE_PROFILE,
  payload: { profile },
});

export const applyZoom = (start, end) => ({
  type: APPLY_ZOOM,
  payload: { zoom: { visible: true, start, end } },
});

export const cancelZoom = () => ({
  type: CANCEL_ZOOM,
});

export const updateCsvExportState = (exportState) => ({
  type: UPDATE_CSV_EXPORT_STATE,
  payload: { exportState },
});
